import { Component, input } from '@angular/core';

import { BaseMediaApiModel } from '@era/inroom-sdk';

@Component({
  selector: 'era-tv-channel',
  templateUrl: './tv-channel.component.html',
  styleUrls: ['./tv-channel.component.scss'],
})
export class TvChannelComponent {
  readonly tvChannel = input.required<BaseMediaApiModel>();
}
